<template>
  <div class="font-gilroy">
    <router-view :key="val"> </router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  },
  mounted() {
    document.title = "Boogi Dashboard";
  },
}
</script>

<style>

</style>
